export default __webpack_public_path__ + "static/media/l.0ff666f4.jpg";